import signUpload from './signUpload';
import uploadToStorage from './uploadToStorage';

/**
 * the following function will either return the URL if it's already uploaded or null
 * otherwise it will sign it and then upload it to Azure Storage then return the Azure Storage URL
 */
export default async function fixImageUri(themeId, endpoint, imageUri) {
  // if falsy default to null
  if (!imageUri) return null;

  // already an S3 URL so just return it
  if (!imageUri.startsWith('data')) return imageUri;

  const signature = await signUpload(themeId, endpoint, imageUri);

  const azStorageUri = await uploadToStorage(signature, imageUri);
  return azStorageUri;
}
